import React from "react";
import { ServerComponentCaller } from "../../helpers";

const ObtencionLicencia = (props) => (
  <ServerComponentCaller
    url={"assets/data/pages/tips/obtencionLicencia.json"}
  />
);

export default ObtencionLicencia;
